import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

/**
 * Directive that listens to DOM changes using MutationObserver Web API
 *
 * How to use:
 *
 * <div (cwDomChange)="onChange($event)" [cwDomChangeOptions]="domChangeOptions">
 *
 * "(cwDomChange)" will call to a method when a mutation is observed.
 *   It passes the resulting mutation record, to know what triggered the mutation observer
 *
 * "[cwDomChangeOptions]" let you change the options for the mutation observer
 */
@Directive({
    selector: '[cwDomChange]',
    standalone: false,
})
export class DomChangeDirective implements OnInit, OnDestroy {
    /** An object providing options that describe which DOM mutations should be reported to mutationObserver's callback */
    @Input() cwDomChangeOptions: MutationObserverInit = {
        attributes: true,
        childList: true,
        characterData: true,
    };

    /** Event that will be called when the mutation observer detects a change in the select DOM element */
    @Output() cwDomChange = new EventEmitter<MutationRecord>();

    private changes!: MutationObserver;

    constructor(private elementRef: ElementRef) {}

    ngOnInit(): void {
        this.startMutationObserver();
    }

    ngOnDestroy(): void {
        this.changes.disconnect();
    }

    private startMutationObserver(): void {
        this.changes = new MutationObserver((mutations: MutationRecord[]) => {
            mutations.forEach((mutation: MutationRecord) => this.cwDomChange.emit(mutation));
        });

        this.changes.observe(this.elementRef.nativeElement, this.cwDomChangeOptions);
    }
}
